










  import { defineComponent, computed, onMounted, onUnmounted, AsyncComponent } from 'vue'
  import { NavigationGuardNext, Route } from 'vue-router/types/router'
  import useCurrentInstance from '~/utils/useCurrentInstance'

  export default defineComponent({
    name: 'Index',
    components: {
      OneCmsGridRender: () => import('~/components/molecules/renders/OneCmsGridRender.vue'),
    },

    beforeRouteEnter(_to: Route, _from: Route, next: NavigationGuardNext) {
      return next((vm: any) => {
        vm.$store.dispatch('products/clearSearchAndListing')
      })
    },
    middleware: ['isAuthenticatedOrPlatformOpened'],

    setup() {
      const vm = useCurrentInstance()

      const mainComponentClass = 'one-index-page'

      const configuration = computed(() => vm.$store.getters['cms/configuration'])
      const getClient = computed(() => vm.$store.getters['account/getClient'])

      const content = computed(() => configuration.value?.content)
      const loggedUser = computed(() => getClient.value ?? null)

      const availableComponents: Record<string, AsyncComponent> = {
        html: () => import('~/components/organisms/grid/shared/OneCmsDynamicComponent.vue'),
        staticHtml: () => import('~/components/organisms/grid/shared/OneCmsStaticComponent.vue'),
        image: () => import('~/components/molecules/images/OneCmsGridImageComponent.vue'),
        link: () => import('~/components/molecules/links/OneCmsGridLinkComponent.vue'),
        Category: () => import('~/components/organisms/grid/content/OneCmsCategoryOverview.vue'),
        productContainer: () => import('~/components/organisms/grid/content/OneCmsProductContainer.vue'),
        TopProducts: () => import('~/components/organisms/grid/content/OneCmsTopProducts.vue'),
        StaticBanners: () => import('~/components/organisms/grid/content/OneCmsStaticBanners.vue'),
        carouselWithCategories: () => import('~/components/organisms/grid/content/OneCmsCategoriesListWithBanner.vue'),
        listWithMegapopup: () => import('~/components/organisms/grid/content/OneCmsCategoriesMegadropdown.vue'),
        customizableProductsRotator: () => import('~/components/organisms/grid/content/OneCmsProductsRotator.vue'),
        carouselWithThumbnails: () => import('~/components/organisms/grid/content/OneCmsCarouselWithThumbnails.vue'),
        youtube: () => import('~/components/organisms/grid/shared/OneCmsYoutubeComponent.vue'),
        textEditor: () => import('~/components/organisms/grid/shared/OneCmsTextEditorComponent.vue'),
        widgetSeparator: () => import('~/components/atoms/OneCmsWidgetSeparator.vue'),
        gridArticle: () => import('~/components/organisms/grid/content/OneCmsArticle.vue'),
        productPack: () => import('~/components/organisms/grid/content/OneCmsProductPack.vue'),
        shopForm: () => import('~/components/organisms/grid/static/OneShopForm.vue'),
      }

      onMounted(() => {
        vm.$plugins.onMounted(mainComponentClass, vm)
      })

      onUnmounted(() => {
        vm.$store.commit('layout/TOGGLE_BACKDROP', false)
        vm.$plugins.onUnmounted(mainComponentClass)
      })

      return {
        mainComponentClass,
        availableComponents,
        content,
        configuration,
        loggedUser,
      }
    },

    fetch({ store }: any) {
      return store.commit('layout/TOGGLE_BREADCRUMBS', false)
    },

    head() {
      const vm = this as any

      return {
        script: [{
          type: 'application/ld+json',
          json: {
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            publisher: {
              name: vm.configuration?.tenantKey,
            },
            mainEntity: {
              '@type': 'Person',
              email: vm.loggedUser?.invoiceEmail,
              name: vm.loggedUser?.name,
              telephone: vm.loggedUser?.phone,
            },
          },
        }],
      }
    },
  })
